(function () {
  if (!('IntersectionObserver' in window)) return;

  const STAGGER_MS = 35;
  const MAX_DELAY_MS = 175;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const item = entry.target;
        const grid = item.closest('.reveal-grid');
        const siblings = grid ? Array.from(grid.querySelectorAll(':scope > .grid__item')) : [item];
        const index = siblings.indexOf(item);
        const delay = Math.min(index, MAX_DELAY_MS / STAGGER_MS) * STAGGER_MS;
        item.style.setProperty('--reveal-delay', delay + 'ms');
        item.classList.add('is-revealed');
        obs.unobserve(item);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  function tagAndObserve() {
    document.querySelectorAll('.collection .grid--view-products, .card-wrapper').forEach(() => {});
    document.querySelectorAll('.collection .grid, ul.grid').forEach((grid) => {
      if (!grid.querySelector(':scope > .grid__item')) return;
      grid.classList.add('reveal-grid');
      grid.querySelectorAll(':scope > .grid__item').forEach((item) => observer.observe(item));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagAndObserve);
  } else {
    tagAndObserve();
  }

  document.addEventListener('shopify:section:load', tagAndObserve);
})();
